export default phpPolyfillObjectFactory;

const module_name = "phpPolyfillObjectModule";
const $inject = [];

function phpPolyfillObjectFactory() {
  class PhpPolyfillObject {
    // TODO Convert to a private property when Webpack supports class properties and private properties
    //static #isConverting = false;

    constructor(value = null) {
      if (!PhpPolyfillObject.isConverting) {
        return new Object(value);
      }

      delete PhpPolyfillObject.isConverting;
    }

    static new() {
      PhpPolyfillObject.isConverting = true;
      return new PhpPolyfillObject();
    }

    static init() {
      let objectMethods = Object.getOwnPropertyDescriptors(Object);
      for (let key in objectMethods) {
        if (Object[key] instanceof Function) {
          //noinspection JSUnresolvedVariable
          Object.defineProperty(PhpPolyfillObject, key, objectMethods[key]);
        }
      }

      delete PhpPolyfillObject.init;
    }

    /**
     * @param {Object} obj
     * @return {PhpPolyfillObject}
     */
    static fromObject(obj) {
      if (obj === null) {
        throw new Error("The parameter was null instead of an Object");
      }

      if (obj.constructor.name !== "Object") {
        throw new Error("The parameter type was " + obj.constructor.name + " instead of Object");
      }

      return Object.create(PhpPolyfillObject.new(), Object.getOwnPropertyDescriptors(obj));
    }

    //noinspection JSUnusedGlobalSymbols
    toObject() {
      return Object.create({}, Object.getOwnPropertyDescriptors(this));
    }

    // Add more methods inspired by PHP below as needed

    //noinspection JSUnusedLocalSymbols
    /**
     *  See https://www.php.net/manual/en/function.array-filter.php
     */
    filter(predicate = ([key, value]) => value) {
      return PhpPolyfillObject.fromObject(Object.fromEntries(Object.entries(this).filter(predicate)));
    }

    /**
     * See https://www.php.net/manual/en/function.array-intersect-key.php
     */
    intersectKey(...objects) {
      return PhpPolyfillObject.fromObject(objects.reduce((previous, obj) => {
        return Object.fromEntries(Object.entries(previous).filter(([key]) => obj.hasOwnProperty(key)));
      }, Object.assign({}, this)));
    }

    /**
     * See https://www.php.net/manual/en/function.array-merge.php
     */
    merge(...objs) {
      return Object.assign(PhpPolyfillObject.new(), this, ...objs);
    }
  }

  PhpPolyfillObject.init();

  return PhpPolyfillObject;
}

phpPolyfillObjectFactory.$inject = $inject;

//noinspection JSValidateTypes
angular.module(module_name, [])
  .factory("PhpPolyfillObjectFactory", phpPolyfillObjectFactory);



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/factories/php-polyfill-object.factory.js
 **/